/**
 * Counter Animation Component
 *
 * @file counter.js
 */

const counter = (() => {
  let counters = [];
  let isAnimating = false;

  // Sayı animasyonu fonksiyonu
  const animateCounter = (element, target, duration = 2000) => {
    const start = 0;
    const increment = target / (duration / 16); // 60fps için
    let current = start;

    const updateCounter = () => {
      current += increment;
      if (current >= target) {
        current = target;
        element.textContent = Math.floor(current).toLocaleString('tr-TR');
        return;
      }
      element.textContent = Math.floor(current).toLocaleString('tr-TR');
      requestAnimationFrame(updateCounter);
    };

    updateCounter();
  };

  // Intersection Observer ile scroll kontrolü
  const initCounterAnimation = () => {
    const counterElements = document.querySelectorAll('.home-future-finance-inner-right-box .number');
    
    if (counterElements.length === 0) return;

    // Her counter için hedef değeri al
    counterElements.forEach(element => {
      const targetValue = parseInt(element.textContent);
      element.setAttribute('data-target', targetValue);
      element.textContent = '0';
      counters.push({ element, target: targetValue, animated: false });
    });

    // Intersection Observer oluştur
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isAnimating) {
          isAnimating = true;
          
          // Tüm counter'ları animasyonla başlat
          counters.forEach(counter => {
            if (!counter.animated) {
              counter.animated = true;
              animateCounter(counter.element, counter.target, 2500);
            }
          });
          
          // Observer'ı durdur
          observer.disconnect();
        }
      });
    }, {
      threshold: 0.5, // Element %50 görünür olduğunda tetikle
      rootMargin: '0px 0px -100px 0px' // Biraz daha erken tetikle
    });

    // İlk counter elementini observe et
    if (counterElements[0]) {
      observer.observe(counterElements[0].closest('.home-future-finance-inner-right'));
    }
  };

  // Reset fonksiyonu (sayfa yeniden yüklendiğinde)
  const resetCounters = () => {
    counters.forEach(counter => {
      counter.element.textContent = '0';
      counter.animated = false;
    });
    counters = [];
    isAnimating = false;
  };

  const init = () => {
    // Sayfa yüklendiğinde başlat
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCounterAnimation);
    } else {
      initCounterAnimation();
    }

    // Sayfa değişimlerinde reset
    window.addEventListener('beforeunload', resetCounters);
  };

  return {
    init,
    resetCounters,
  };
})();

export default counter;
